import { Button } from "components/DesignSystem/Button/Button";
import FocusBlock from "components/DesignSystem/FocusBlock/FocusBlock";
import { Padlock } from "components/icons/Padlock";
import { SmallPlusIcon } from "components/icons/export const SmallPlusIcon";
import { LockedUi } from "components/LockedUi/LockedUi";
import { WritePermissionKey } from "constants/permissions";
import { ComponentProps } from "react";

type AddLineItemButtonProps = {
  writePermissionKey: WritePermissionKey;
  onClick: () => void;
  size?: ComponentProps<typeof Button>["size"];
};

export const AddLineItemButton = ({
  writePermissionKey,
  onClick,
  size = "small",
}: AddLineItemButtonProps) => (
  <LockedUi
    feature={writePermissionKey}
    blockedUi={
      <Button type="button" customType="secondary" size={size} disabled>
        <span className="t-flex t-items-center t-gap-2">
          <Padlock />
          Add line item
        </span>
      </Button>
    }
  >
    <FocusBlock.Trigger asChild>
      <Button
        type="button"
        customType="secondary"
        size={size}
        onClick={onClick}
      >
        <span className="t-flex t-items-center t-gap-2">
          <SmallPlusIcon /> Add line item
        </span>
      </Button>
    </FocusBlock.Trigger>
  </LockedUi>
);
